import type { User } from "@ferrivia/api-contract";

/**
 * Two-letter monogram for the signed-in staff user's avatar. Shared by the
 * desktop nav rail and the mobile account sheet so the same person is
 * recognisable in both shells.
 */
export function initials(user: User): string {
  const local = user.email?.split("@")[0] ?? "";
  const parts = local.split(/[._-]+/).filter(Boolean);
  const letters = parts.length > 1 ? [parts[0], parts[1]] : [local.slice(0, 2)];
  return letters.join("").slice(0, 2).toUpperCase() || "?";
}
